import React from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../Axios-Config/Axios-Config";
import { SETUSERDATA } from "../../redux/features/userData";
import LoaderButton from "../Buttons/LoaderButton";
import InputText from "../FormFields/InputText";
import { ErrorToast } from "../ToastComponent/ErrorToast";
import { SuccessToast } from "../ToastComponent/SuccessToast";
import { registerFormInitial, registerFormSchema } from "./RegisterValidation";
import Konsole from "../../utils/konsole/Konsole";
import { setCookie } from "../../utils/helper";
import GlobalButton from "../Buttons/btn2/GlobalButton";

export default function RegisterView() {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  Konsole.log("isSubmitting", isSubmitting);
  const [isLoader, setIsLoader] = useState(false);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const {
    handleSubmit,
    formState: { errors },
    register,
    // setValue,
    // getValues,
    reset,
  } = useForm({
    resolver: yupResolver(registerFormSchema),
    defaultValues: registerFormInitial,
  });

  const registerFormSubmit = async (state: any) => {
    setIsSubmitting(false);
    try {
      setIsLoader(true);
      const { data } = await axiosInstance.post("/complete/profile", state);
      if (data.success) {
        SuccessToast(data.message);
        dispatch(SETUSERDATA(data?.user_data));
        setCookie('user-data',JSON.stringify(data?.user_data),7)
        setIsLoader(false);
        reset();
        navigate("/menu");
      } else {
        ErrorToast(data.message);
      }
      return false;
    } catch (error: any) {
      ErrorToast(error.message);
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit(registerFormSubmit)}>
        <div className="  h-screen md:p-20">
          <div className="store-card menu max-w-[26rem]  m-auto h-screen md:h-auto">
            <h1 className="font-normal text-2xl font-splekta mb-3">
              {t("Register.completeYourProfile")}
            </h1>
            <p className="text-[#606060] textMd font-normal mb-6">
              {t("Register.weNeedYourNameEmail")}
            </p>
            <div className="formItem">
              <InputText
                placeholder={`${t("Register.enterFirstName")}*`}
                name="first_name"
                register={register}
                className={"formControl ubermoveTextMedium"}
              />
              <div className="errorFields">
                {errors.first_name?.message
                  ? t(errors.first_name?.message)
                  : ""}
              </div>
            </div>
            <div className="formItem">
              <InputText
                placeholder={`${t("Register.enterLastName")}*`}
                name="last_name"
                register={register}
                className={"formControl ubermoveTextMedium"}
              />
              <div className="errorFields">
                {errors.last_name?.message ? t(errors.last_name?.message) : ""}
              </div>
            </div>
            <div className="formItem">
              <InputText
                placeholder={t("Register.enterEmail")}
                name="email"
                register={register}
                className={"formControl ubermoveTextMedium"}
              />
              <div className="errorFields">
                {errors.email?.message ? t(errors.email?.message) : ""}
              </div>
            </div>

              <GlobalButton  label= {t("MyAddress.submit")} type={'submit'} loading={isLoader}/>
          </div>
        </div>
      </form>
      {/* <div className="grid md:grid-cols-2 p-3 h-screen">
        <div className="md:mx-20 mx-5">
          <div className="flex justify-between">
            <div className="logo">
              <img src="/logo.png" />
            </div>
          </div>
          <div className="my-16">
            <h1 className="text-4xl font-medium mb-3">
              {t("Register.register")}
            </h1>
            <p className="text-base font-medium">
              {t("Register.registerText")}
            </p>
          </div>
          <form onSubmit={handleSubmit(registerFormSubmit)} className="mb-10">
            <div className="formItem">
              <LabelText text={t("Register.firstName")} />
              <InputText
                placeholder={t("Register.enterFirstName")}
                name="first_name"
                register={register}
              />
              {errors?.first_name?.message ? errors?.first_name?.message : ""}
            </div>
            <div className="formItem">
              <LabelText text={t("Register.lastName")} />
              <InputText
                placeholder={t("Register.enterLastName")}
                name="last_name"
                register={register}
              />
              {errors?.last_name?.message ? errors?.last_name?.message : ""}
            </div>
            <div className="formItem">
              <LabelText text={t("Register.email")} />
              <InputText
                placeholder={t("Register.enterEmail")}
                name="email"
                register={register}
              />
              {errors?.email?.message ? errors?.email?.message : ""}
            </div>
            <button type="submit" className="btnBlue !rounded-full mt-10">
              {t("Register.register")}
            </button>
            <Link
              to="/menu"
              className="text-center textBlue p-2 cursor-pointer block"
            >
              {t("Register.skip")}
            </Link>
          </form>
        </div>

        <div className="rounded-lg overflow-hidden hidden md:block">
          <img src="/images/login-banner.png" />
        </div>
      </div> */}
    </>
  );
}
